import React from "react";
import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import { MEDIA } from "@/lib/media";
import { WaveDivider, Paw } from "@/components/decor";

export default function OurStory() {
  useSeo("Our Story — How Two Bulldogs Became a Business",
    "The Happy Bulldog Co. grew from the personality and adventures of Karen's real British Bulldogs, Chewie and Solo.");
  return (
    <div>
      <section className="relative bg-[#4CC9F0]/20 py-14 sm:py-20 text-center overflow-hidden">
        <div className="relative max-w-3xl mx-auto px-4 sm:px-6">
          <span className="font-hand text-2xl text-[#FF6B9D]">Our story</span>
          <h1 className="font-display font-extrabold text-3xl sm:text-5xl text-[#19324A] mt-1">HOW TWO BULLDOGS BECAME A BUSINESS</h1>
        </div>
        <WaveDivider color="#FFF9EE" />
      </section>

      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="rounded-[2rem] overflow-hidden soft-shadow ring-4 ring-white mb-10"><img src={MEDIA.heroDogs} alt="Chewie and Solo" className="w-full object-cover" /></div>
        <div className="space-y-5 text-[#19324A]/85 text-lg leading-relaxed">
          <p>The Happy Bulldog Co.™ grew from the personality and adventures of Karen's real British Bulldogs, <strong>Chewie and Solo</strong>.</p>
          <p>Their antics inspired the creation of the children's book <em>Chewie & Solo — The Great Biscuit Bonanza</em>. The characters and their world then grew beyond the books into products that allow readers, Bulldog lovers and families to share some of the happiness and humour Chewie and Solo bring to everyday life.</p>
          <p className="font-hand text-3xl text-[#FF6B9D] text-center py-4">From our home to yours — welcome to The Happy Bulldog Co.™</p>
        </div>
      </section>

      {/* Author */}
      <section id="author" className="relative bg-[#7ED957]/15 py-14 sm:py-20 scroll-mt-24">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 grid md:grid-cols-[280px_1fr] gap-10 items-center">
          <div className="mx-auto">
            <div className="w-64 h-64 rounded-full overflow-hidden ring-8 ring-white soft-shadow">
              <img src={MEDIA.founder} alt="Karen Bird, founder of The Happy Bulldog Co., with Chewie and Solo" className="w-full h-full object-cover" style={{ objectPosition: "center 20%" }} />
            </div>
          </div>
          <div>
            <span className="font-hand text-2xl text-[#4CC9F0]">Meet the author</span>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-[#19324A]">Karen Bird</h2>
            <p className="font-display font-semibold text-[#FF6B9D] mt-1">Author • Creator • Bulldog Mum</p>
            <p className="mt-4 text-[#19324A]/80 text-lg leading-relaxed">Karen is the creator of the Chewie & Solo Adventures and the human behind The Happy Bulldog Co.™. Inspired by the very real personalities and mischief of her British Bulldogs, Chewie and Solo, she turned their everyday antics into stories designed to make children and grown-ups laugh together.</p>
            <Link to="/meet" className="btn-outline mt-6 inline-flex">Meet Chewie & Solo</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
